module.exports = __webpack_public_path__ + "static/media/congratulate.bd4bd6c1.svg";